function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 1.5C6.64873 1.5 1.5 6.64873 1.5 13C1.5 19.3513 6.64873 24.5 13 24.5C19.3513 24.5 24.5 19.3513 24.5 13C24.5 6.64873 19.3513 1.5 13 1.5ZM0.5 13C0.5 6.09644 6.09644 0.5 13 0.5C19.9036 0.5 25.5 6.09644 25.5 13C25.5 19.9036 19.9036 25.5 13 25.5C6.09644 25.5 0.5 19.9036 0.5 13Z",
  fill: "#697B8B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9076 10.029C18.8374 9.76764 18.6998 9.52925 18.5086 9.33774C18.3173 9.14622 18.0791 9.00831 17.8177 8.93779C16.8558 8.67908 13 8.67908 13 8.67908C13 8.67908 9.14408 8.67908 8.18218 8.93641C7.92074 9.0067 7.68241 9.14454 7.4911 9.33609C7.2998 9.52764 7.16226 9.76615 7.09229 10.0277C6.83496 10.991 6.83496 13.0001 6.83496 13.0001C6.83496 13.0001 6.83496 15.0092 7.09229 15.9711C7.23403 16.5023 7.65237 16.9206 8.18218 17.0624C9.14408 17.3211 13 17.3211 13 17.3211C13 17.3211 16.8558 17.3211 17.8177 17.0624C18.3489 16.9206 18.7659 16.5023 18.9076 15.9711C19.165 15.0092 19.165 13.0001 19.165 13.0001C19.165 13.0001 19.165 10.991 18.9076 10.029ZM11.7752 14.8441V11.1561L14.9678 12.9863L11.7752 14.8441Z",
  fill: "#697B8B"
});

var SvgYt = function SvgYt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yt.75079750.svg";
export { ForwardRef as ReactComponent };